import type { ITwoFactorLocale } from '@/Pages/Onboard/TwoFactor/Locale/TwoFactor.locale';

const ptBR: ITwoFactorLocale = {
  title: 'Autenticação em dois fatores',
  subtitle: {
    configuring: 'Configurando seu 2FA…',
    error: 'Não foi possível iniciar a configuração.',
    scan: 'Escaneie o QR Code abaixo com seu app autenticador (Google Authenticator, Authy etc.). Aponte a câmera do seu app para este código:',
  },
  generatingQRCode: 'Gerando QR Code…',
  qrAlt: 'QR Code 2FA',
  cannotScan: 'Não consegue escanear?',
  useCodeBelow: 'Use o código abaixo:',
  secret: {
    label: 'Código de configuração',
    placeholder: '-',
    copyHint: 'Copie e cole este código diretamente no seu app autenticador',
    copied: 'Copiado!',
  },
  verification: {
    label: 'Código de verificação',
    placeholder: '_ _ _ _ _ _',
    hint: 'Insira o código de 6 dígitos gerado no seu app. Ele se atualiza a cada 30 segundos.',
  },
  button: {
    verify: 'Verificar',
    verifyAndEnter: 'Verificar e entrar',
  },
  success: {
    title: '2FA ativado com sucesso!',
    subtitle: 'Sua conta agora exige código do app autenticador no login.',
  },
  errors: {
    initSessionExpired: 'Sessão de configuração expirada. Faça login novamente.',
    finishSessionExpired: 'Sessão expirada. Faça login novamente.',
    tooManyAttempts: 'Muitas tentativas. Tente novamente em alguns segundos.',
    configRequired: 'Configuração necessária. Recarregue o login.',
    initGeneric: 'Erro ao inicializar 2FA',
    invalidCode: 'Código inválido. Verifique e tente novamente.',
    initFirst: 'Inicie a configuração novamente.',
    finishGeneric: 'Erro ao finalizar 2FA',
    sessionMissing: 'Sessão de configuração ausente. Faça login novamente.',
  },
};
export { ptBR };
